module.exports = __webpack_public_path__ + "assets/img/mecha-info-title-2e3f7c06.png";